(async () => {
  const {updateURLParams, historyPush, parseHTML} = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);
  customElements.define('product-form', class extends baseComponent.default {
    elements = {form:'form',addButton:'[data-add-button]',buyButton:'[data-buy-button]',soldOutButton:'[data-sold-out-button]',input:'[data-variant-id-input]',sellingPlanInput:'input[name="selling_plan"]'};
    async render() {
      if (!this.$form || !this.$input) return;
      this.$input.disabled = !this.$input.value;
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';
      this.listenTo('variantChange', (e,data) => {
        this.qtyRequestId=(this.qtyRequestId||0)+1;
        this.qtyController?.abort();
        this._rerender(data);
        this._rerenderVariantInput(data);
      });
      this.on('cartChange',(e,data)=>this._updateQtyStatus(data.variantId),false);
      if(this.hasAttribute('cart-popup')) this.$form.addEventListener('submit',e=>this._handleSubmit(e));
      if(this.$sellingPlanInput && this.hasAttribute('selling-plan-enable')) {
        this.currentSellingPlanId=this.$sellingPlanInput.value;
        const {observeInputValueChange}=await import(window.theme.modules.sellingPlanUtil);
        observeInputValueChange(this.$sellingPlanInput,id=>this._handleSellingPlanChange(id));
      }
    }
    _message(text,error=false) {
      if(!this.message){this.message=document.createElement('p');this.message.setAttribute('data-product-message','');this.message.setAttribute('role','status');this.message.setAttribute('aria-live','polite');this.$form.appendChild(this.message);}
      this.message.textContent=text;
      if(!error && text){const link=document.createElement('a');link.href=window.routes.cart_url;link.textContent=' View cart';this.message.appendChild(link);}
    }
    async _handleSellingPlanChange(id) {
      if(id===this.currentSellingPlanId)return;
      this.currentSellingPlanId=id;
      const version=this.planRequestId=(this.planRequestId||0)+1;
      const {queryURL,currentURL}=updateURLParams({selling_plan:id,variant:this.getAttribute('current-variant')},this.sectionId);
      try{const html=await this._fetchPageWithVariant(queryURL);if(version!==this.planRequestId || !this.isConnected)return;if(this.isProductPage)historyPush(currentURL);this.forwardEvent('sellingPlanChange',{html});}
      catch{if(version===this.planRequestId)this._message('This purchase option could not be loaded. Please refresh before adding.',true);}
    }
    async _fetchPageWithVariant(url,signal) {
      const response=await fetch(url,{signal,cache:'no-store'});
      if(!response.ok)throw new Error('Product could not be refreshed');
      return parseHTML(await response.text());
    }
    _source(html){return Array.from(html?.querySelectorAll('product-form')||[]).find(node=>node.getAttribute('form-id')===this.getAttribute('form-id'));}
    _rerender(data) {
      const source=this._source(data.html);
      const add=source?.querySelector('[data-add-button]'),sold=source?.querySelector('[data-sold-out-button]');
      if(!add || !sold){this.$addButton.disabled=true;this.$input.disabled=true;if(this.$buyButton)this.$buyButton.hidden=true;this._message('This option could not be loaded. Please refresh the page.',true);return;}
      this.$addButton.hidden=add.hidden;
      this.$addButton.disabled=this.pending || add.disabled;
      if(this.$buyButton)this.$buyButton.hidden=add.hidden;
      if(this.$soldOutButton)this.$soldOutButton.hidden=sold.hidden;
    }
    _rerenderVariantInput(data) {
      const input=this._source(data.html)?.querySelector(this.elements.input);
      if(!data.variant || !input?.value){this.$input.value='';this.$input.disabled=true;this.$addButton.disabled=true;if(this.$buyButton)this.$buyButton.hidden=true;return;}
      this.setAttribute('current-variant',String(data.variant.id));this.$input.value=input.value;this.$input.disabled=false;
    }
    _handleSubmit(event) {
      event.preventDefault();
      if(this.pending || this.$input.disabled || !this.$form.reportValidity())return;
      return this._addToCartRequest(new FormData(this.$form));
    }
    async _addToCartRequest(formData) {
      if(this.pending)return;
      this.pending=true;this._setLoading(true);this._message('');
      const id=formData.get('id');let added=false;
      try {
        const response=await fetch(window.routes.cart_add_url+'.js',{method:'POST',headers:{Accept:'application/json'},body:formData});
        const data=await response.json();
        if(!response.ok || data.status)throw new Error(data.description || 'This item could not be added. Please check your selection.');
        added=true;this._message('Added to your cart.');
      }catch(error){this._message(error instanceof TypeError?'We could not confirm the addition. Please check your cart before trying again.':error.message,true);}
      finally{this.pending=false;this._setLoading(false);}
      if(added){
        this._updateQtyStatus(id);
        this.trigger('updateCart',{callback:()=>{if(!this.isConnected)return;if(this.cartSection)this.cartSection.update();else this.trigger('openPopup',{target:'CART'});}});
      }
    }
    async _updateQtyStatus(variantId) {
      if(!variantId || String(variantId)!==this.getAttribute('current-variant'))return;
      this.qtyController?.abort();this.qtyController=new AbortController();
      const id=this.qtyRequestId=(this.qtyRequestId||0)+1;
      const url=new URL(this.getAttribute('product-url'),window.location.origin);url.searchParams.set('variant',variantId);url.searchParams.set('section_id',this.sectionId);
      try{const html=await this._fetchPageWithVariant(url,this.qtyController.signal);if(id!==this.qtyRequestId || !this.isConnected || String(variantId)!==this.getAttribute('current-variant'))return;this.trigger('qtyStatusUpdate',{html,variantId});this._rerender({html});}catch{/* The addition is already confirmed; a refresh failure must not report a failed add. */}
    }
    _setLoading(loading) {
      this.setAttribute('aria-busy',String(loading));
      this.$addButton.toggleAttribute('loading',loading);
      this.$addButton.disabled=loading || this.$input.disabled;
    }
    disconnectedCallback(){super.disconnectedCallback();this.qtyController?.abort();this.qtyRequestId=(this.qtyRequestId||0)+1;this.planRequestId=(this.planRequestId||0)+1;}
  });
})();
